import React, { useState } from 'react';
import { Outlet, Link, useNavigate } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';
import { LanguageToggle, useLanguage } from '../context/LanguageContext';
import './MemberLayout.css';

const MemberLayout = () => {
  const { user, logout } = useAuth();
  const navigate = useNavigate();
  const [menuOpen, setMenuOpen] = useState(false);
  const { t } = useLanguage();

  const handleLogout = async () => {
    await logout();
    navigate('/');
  };

  const closeMenu = () => {
    setMenuOpen(false);
  };

  return (
    <div className="member-layout">
      <button
        type="button"
        className="mobile-menu-toggle"
        onClick={() => setMenuOpen((open) => !open)}
        aria-label={menuOpen ? t('nav.closeMenu') : t('nav.openMenu')}
        aria-expanded={menuOpen}
      >
        {menuOpen ? '✕' : '☰'}
      </button>

      <div className={`member-sidebar ${menuOpen ? 'open' : ''}`}>
        <div className="sidebar-header">
          <h2>{t('nav.member')}</h2>
          <p>{user?.profile?.chinese_name || user?.phone_number}</p>
          <LanguageToggle />
          <button type="button" className="member-sidebar-close" onClick={closeMenu} aria-label={t('nav.closeMenu')}>
            ✕
          </button>
        </div>
        <nav className="sidebar-nav">
          <Link to="/member" onClick={closeMenu}>{t('nav.dashboard')}</Link>
          <Link to="/member/profile" onClick={closeMenu}>{t('nav.profile')}</Link>
          <Link to="/member/qr-code" onClick={closeMenu}>{t('nav.myQr')}</Link>
          <Link to="/member/events" onClick={closeMenu}>{t('nav.myEvents')}</Link>
          <Link to="/member/change-password" onClick={closeMenu}>{t('nav.password')}</Link>
          <Link to="/" onClick={closeMenu}>{t('nav.backHome')}</Link>
          <button onClick={handleLogout} className="btn btn-secondary">{t('nav.logout')}</button>
        </nav>
      </div>
      {menuOpen && <div className="sidebar-overlay" onClick={closeMenu}></div>}
      <div className="member-content">
        <Outlet />
      </div>
    </div>
  );
};

export default MemberLayout;
